(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbs-seller-intake"] && !Shopify.designMode) return;
  try {
    
(() => {
  async function send(url, options, timeout) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try { return await fetch(url, { ...options, signal: controller.signal }); }
    finally { clearTimeout(timer); }
  }
  const bind = () => document.querySelectorAll('[data-seller-form]').forEach(form => {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const originalLabel = button.textContent;
    status.tabIndex = -1;
    status.setAttribute('aria-atomic', 'true');
    function message(text, state, reveal = false) {
      status.textContent = text;
      status.dataset.state = state;
      status.setAttribute('role', state === 'error' ? 'alert' : 'status');
      if (reveal) {
        status.scrollIntoView({ behavior: 'smooth', block: 'center' });
        status.focus({ preventScroll: true });
      }
    }
    button.disabled = false;
    form.addEventListener('invalid', event => {
      const input = event.target;
      const label = input.labels?.[0]?.textContent?.trim().replace(/\s+/g, ' ');
      message(label ? 'Please check the highlighted field: ' + label : 'Please complete the highlighted required field.', 'error');
    }, true);
    form.addEventListener('change', event => {
      if (event.target.type !== 'file' || !window.TBSUploadPhotos) return;
      try {
        for (const file of event.target.files) window.TBSUploadPhotos.validate(file);
        event.target.removeAttribute('aria-invalid');
      } catch (error) {
        event.target.setAttribute('aria-invalid', 'true');
        message(error.message, 'error', true);
      }
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.busy || (form.dataset.photoPreview !== 'true' && !form.reportValidity())) return;
      const inputs = [...form.querySelectorAll('[type="file"]')];
      let sent = false;
      form.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = 'Preparing photographs…';
      message('Preparing your photographs. Larger photos are resized automatically before upload.', 'sending', true);
      try {
        if (!window.TBSUploadPhotos) throw new Error('The photo uploader did not finish loading. Refresh the page and try again.');
        const data = new FormData(form);
        const chosen = inputs.filter(input => input.files.length);
        for (const input of inputs) data.delete(input.name);
        let count = 0;
        // Process sequentially so multiple large phone photos do not remain decoded together.
        for (const input of chosen) {
          const prepared = await window.TBSUploadPhotos.prepare(input.files[0]);
          data.append(input.name, prepared, prepared.name);
          message('Preparing photograph ' + (++count) + ' of ' + chosen.length + '…', 'sending');
        }
        if (form.dataset.photoPreview === 'true') {
          message('Photo test passed. Your ' + count + ' photograph(s) were prepared successfully. This is an unpublished test: no submission was created and no email was sent.', 'success', true);
          delete form.dataset.busy;
          button.disabled = false;
          button.textContent = 'Run photo test again';
          return;
        }
        const endpoint = form.action;
        const tokenResponse = await send(endpoint + '/token', { credentials: 'omit', cache: 'no-store' }, 20000);
        if (!tokenResponse.ok) throw new Error(tokenResponse.status === 429 ? 'Too many attempts. Please wait a few minutes and try again.' : 'A secure connection could not be started. Please try again.');
        const session = await tokenResponse.json();
        if (typeof session.token !== 'string' || !/^[A-Za-z0-9_-]{43}$/.test(session.token)) throw new Error('A secure connection could not be started. Please try again.');
        button.textContent = 'Sending your submission…';
        message(form.dataset.sending, 'sending');
        sent = true;
        const response = await send(endpoint, { method: 'POST', credentials: 'omit', headers: { 'X-Intake-Token': session.token }, body: data }, 90000);
        let result;
        try { result = await response.json(); } catch { result = {}; }
        if (!response.ok) {
          if (response.status === 413) throw new Error('The upload was too large. Choose fewer or smaller photographs and try again. Your details have been kept.');
          if (response.status === 429) throw new Error('Too many attempts. Please wait a few minutes and try again.');
          throw new Error(response.status === 400 && typeof result.error === 'string' ? result.error.slice(0, 500) : form.dataset.error);
        }
        if (result.received !== true) throw new Error(form.dataset.error);
        message(form.dataset.success, 'success', true);
        button.textContent = 'Submission received';
        form.querySelectorAll('input,select,textarea').forEach(input => input.disabled = true);
      } catch (error) {
        const text = error.name === 'TimeoutError' || error.name === 'AbortError' || error instanceof TypeError ? (sent ? form.dataset.error : 'The connection timed out. Your details and selected photos have been kept. Please try again.') : error.message;
        message(text || form.dataset.error, 'error', true);
        delete form.dataset.busy;
        button.disabled = false;
        button.textContent = originalLabel;
      }
    });
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbs-seller-test-oct15"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = () => document.querySelectorAll('[data-seller-test-form]').forEach(form => {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[role="status"]');
    button.disabled = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.busy || !form.reportValidity()) return;
      const files = [...form.querySelectorAll('[type="file"]')].flatMap(input => [...input.files]);
      if (files.some(file => file.size > 5 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type))) {
        status.textContent = form.dataset.photoError;
        return;
      }
      form.dataset.busy = 'true';
      button.disabled = true;
      status.textContent = form.dataset.sending;
      try {
        const endpoint = form.action;
        const tokenResponse = await fetch(endpoint + '/token', { credentials: 'omit', cache: 'no-store' });
        if (!tokenResponse.ok) throw new Error('connection');
        const session = await tokenResponse.json();
        const data = new FormData(form);
        for (const [name, value] of [...data]) {
          if (value instanceof File && !value.name) data.delete(name);
        }
        const response = await fetch(endpoint, {
          method: 'POST', credentials: 'omit', headers: { 'X-Intake-Token': session.token }, body: data
        });
        if (!response.ok) throw new Error('submission');
        status.textContent = form.dataset.success;
        form.querySelectorAll('input,select,textarea').forEach(input => input.disabled = true);
      } catch {
        status.textContent = form.dataset.error;
        delete form.dataset.busy;
        button.disabled = false;
      }
    });
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();
})();
